import {
	AttachmentStatus,
	AttachmentType,
	type FileAttachment as FileAttachmentType,
} from '@/states/attachment'
import { css } from '@emotion/react'
import {
	type HTMLAttributes,
	type MouseEventHandler,
	type ReactElement,
	type RefObject,
	forwardRef,
} from 'react'
import ClickWrapper from '../ClickWrapper'
import Attachment from './Attachment'

export type FileAttachmentElement = HTMLImageElement | HTMLVideoElement
export interface FileAttachmentProps
	extends HTMLAttributes<HTMLImageElement | HTMLVideoElement | HTMLDivElement> {
	data: FileAttachmentType
	onDelete?: () => void
}

export default forwardRef<FileAttachmentElement, FileAttachmentProps>(function FileAttachment(
	{ data, onDelete, onClick, ...props }: FileAttachmentProps,
	ref
) {
	const status = data.status

	let content: ReactElement | null = null
	const src = !data.file?.size ? data.cdn?.file.fileUrl : URL.createObjectURL(data.file)

	if (!src) {
		return null
	}
	switch (data.type) {
		case AttachmentType.PICTURE:
			content = (
				<img
					ref={ref as RefObject<HTMLImageElement>}
					src={src}
					css={css`
						height: 100%;
						width: 100%;
						object-fit: cover;
					`}
					{...(props as HTMLAttributes<HTMLImageElement>)}
				/>
			)
			break
		case AttachmentType.VIDEO:
			content = (
				<video
					src={src}
					muted
					ref={ref as RefObject<HTMLVideoElement>}
					css={css`
						height: 100%;
						width: 100%;
						object-fit: cover;
					`}
					{...(props as HTMLAttributes<HTMLVideoElement>)}
				/>
			)
			break
	}

	if (content === null) {
		return null
	}

	return (
		<ClickWrapper onClick={onClick as MouseEventHandler<HTMLDivElement>}>
			<Attachment
				isLoading={status === AttachmentStatus.UPLOADING}
				key={data.id}
				onClose={onDelete}
				css={css`
					.content {
						width: 80px;
						height: 80px;
						border-radius: 8px;
						border: 1px solid var(--tint-pic-border);
						overflow: hidden;
					}
				`}
			>
				{content}
			</Attachment>
		</ClickWrapper>
	)
})
